import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import profileImage from "../assets/images/t-01.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider";
import logoImage from "../assets/images/logo.png";
import aisImage from "../assets/images/ais_mamman.png";
import { getProducts } from "../features/product";
import AuthModal from "../components/AuthModal";

const Header = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { products, status } = useSelector((state) => state.product);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = localStorage.getItem("token") ?? "";
  const { logout, modalIsOpen, setModalIsOpen } = useAuth();
  const ASSET_BASE = process.env.REACT_APP_CURRENT_ENV || "";


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.body.dir = lng === "ar" ? "rtl" : "ltr";
    localStorage.setItem("language", lng);
    const linkElement = document.getElementById("dynamic-stylesheet");
    if (lng === "ar") {
      linkElement.href = `${ASSET_BASE}/rtl.css`;
    } else if (lng === "en") {
      linkElement.href = `${ASSET_BASE}/ltr.css`;
    }
  };
  useEffect(() => {
    const linkElement = document.getElementById("dynamic-stylesheet");
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
    document.body.dir = savedLanguage === "ar" ? "rtl" : "ltr";
    if (savedLanguage === "ar") {
      linkElement.href = `${ASSET_BASE}/rtl.css`;
    } else {
      linkElement.href = `${ASSET_BASE}/ltr.css`;
    }
  }, [i18n, status]);

  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };
  const handleShowOffcanvas = () => setShowOffcanvas(true);

  const handleNavigation = (path) => {
    navigate(path);
    handleCloseOffcanvas();
  };

  const handleProductNavigation = (path, index) => {
    // // console.log('path', path);

    if (products && products.length) {
      localStorage.setItem(
        "product_details",
        JSON.stringify({
          product_id: products[index]?.id,
          sub_product_id: products[index]?.sub_products[0]?.id,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);

  useEffect(() => {
    if (modalIsOpen) {
      handleCloseOffcanvas();
    }
  }, [modalIsOpen]);

  return (
    <>
      <header className="header">
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand
              style={{ cursor: "pointer", display: "flex", width: "15%" }}
            >
              <img
                src={aisImage}
                alt="logo"
                // className="img-fluid"
                style={{ height: "auto" }}
                onClick={() => navigate("/")}
              />
              <a
                className="language-btn"
                onClick={() =>
                  currentLanguage === "en"
                    ? changeLanguage("ar")
                    : changeLanguage("en")
                }
              >
                {currentLanguage === "en" ? t("arabic") : t("english")}
              </a>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar"
              onClick={handleShowOffcanvas}
            />
            <Navbar.Offcanvas
              show={showOffcanvas}
              onHide={handleCloseOffcanvas}
              id="offcanvasNavbar"
              aria-label="offcanvasNavbarLabel"
              placement={currentLanguage === "ar" ? "end" : "start"}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel">
                  {t("menu")}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="flex-grow-1">
                  <Nav.Link onClick={() => handleNavigation("/")}>
                    {t("navbar.home")}
                  </Nav.Link>
                  <Nav.Link onClick={() => handleNavigation("/about")}>
                    {t("navbar.about_us")}
                  </Nav.Link>
                  <NavDropdown
                    title={t("insurance")}
                    onClick={() => handleNavigation("/insurance")}
                    show={show}
                    onMouseEnter={() => setShow(true)}
                    onMouseLeave={() => setShow(false)}
                    className="insurance-dropdown"
                  >
                    {products &&
                      products.length > 0 &&
                      products.map((product, index) => (
                        <NavDropdown.Item
                          key={"product-menu-" + index}
                          onClick={() =>
                            handleProductNavigation(
                              `/product/${product.product_name.replaceAll(
                                " ",
                                "-"
                              )}`,
                              index
                            )
                          }
                          href={`product/${product.product_name.replaceAll(
                            " ",
                            "-"
                          )}`}
                        >
                          <span>
                            {currentLanguage === "ar"
                              ? product.product_name_ar
                              : product.product_name}
                          </span>
                        </NavDropdown.Item>
                      ))}
                  </NavDropdown>

                  <Nav.Link onClick={() => handleNavigation("/contact")}>
                    {t("navbar.contact_us")}
                  </Nav.Link>
                  <Nav.Link onClick={() => handleNavigation("/transaction-history")}>
                    {t("navbar.transaction_history") || "Transaction History"}
                  </Nav.Link>
                  <Nav.Link
                    className="btn h-btn"
                    onClick={() => handleNavigation("/request-tracking")}
                  >
                    {t("navbar.request_tracking")}
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        {/* Black Beta Banner */}
        <div className="beta-banner my-4">
          <div className="container d-flex align-items-center justify-content-between">
            <div className="beta-content">
              <span className="beta-badge">{t("beta.badge")}</span>
              <span className="beta-text">
                {t("beta.publicTesting")}{" "}
                <a href="/contact" className="beta-link">
                  {t("beta.reportFeedback")}
                </a>
              </span>
            </div>
          </div>
        </div>
      </header>

      {modalIsOpen && (
        <AuthModal modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      )}
    </>
  );
};

export default Header;
